import { render } from "./VanillaA.vue?vue&type=template&id=12a006e3&scoped=true"
import script from "./VanillaA.vue?vue&type=script&lang=js"
export * from "./VanillaA.vue?vue&type=script&lang=js"

import "./VanillaA.vue?vue&type=style&index=0&id=12a006e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a006e3"]])

export default __exports__